import React from 'react';
import { InvestmentKnowledge as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import Section from '../Section';
import RadioInput from '../Fields/RadioInput';

const InvestmentKnowledge = () => (
  <Section
    title="Investment Knowledge"
    sectionKey={SectionKey}
    expanded={QueryVal(section) === SectionKey}
  >
    Please enter your knowledge of the following:
    <RadioInput
      label="Stocks"
      name="investmentKnowledgeStocks"
      answerKey="investmentKnowledgeStocks"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Bonds"
      name="investmentKnowledgeBonds"
      answerKey="investmentKnowledgeBonds"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Mutual funds"
      name="investmentKnowledgeMutualFunds"
      answerKey="investmentKnowledgeMutualFunds"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Options"
      name="investmentKnowledgeOptions"
      answerKey="investmentKnowledgeOptions"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Variable annuities"
      name="investmentKnowledgeVariableAnnuities"
      answerKey="investmentKnowledgeVariableAnnuities"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Variable life"
      name="investmentKnowledgeVariableLife"
      answerKey="investmentKnowledgeVariableLife"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
    <RadioInput
      label="Alternatives"
      name="investmentKnowledgeAlternatives"
      answerKey="investmentKnowledgeAlternatives"
      options={[
        {
          id: 'None',
          text: 'None',
        },
        {
          id: 'Limited',
          text: 'Limited',
        },
        {
          id: 'Good',
          text: 'Good',
        },
        {
          id: 'Extensive',
          text: 'Extensive',
        },
      ]}
    />
  </Section>
);

export default InvestmentKnowledge;
